import React, { useCallback, useEffect, useRef, useState } from "react";
import { everyTrue } from "@/helper/helper";
import { useUserUrl } from "@/states/qr_types/url.state";
import { IoMdInformationCircle, IoMdInformationCircleOutline } from "react-icons/io";
import IFThen from "@/components/common/IFThen";
import { useSolutionsSelect } from "@/states/solution.state";
import { HomePageError } from "@/components/common/HomePageError";
import { useSignUpModal } from "@/states/ui.state";
import { useConfig, useError } from "@/states/common.state";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import { useMediaQuery } from "react-responsive";
import { useTranslations } from "next-intl";
import debounce from "lodash/debounce";
import classes from "./UrlHomepage.module.scss";
import useUrlInput from "@/hooks/common/useUrlInput";
import { HiCheckCircle, HiExclamationCircle } from "react-icons/hi";
import { When } from "@/components/common/When";
import TypeInput from "../_shared/TypeInput";
const Url = () => {
  const t = useTranslations("QrTypes.website");
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const {
    error: validationErrors
  } = useError();
  const {
    config,
    setIsLoading
  } = useConfig();
  const {
    url: currentUrl,
    setParams,
    setSuccess,
    success
  } = useUserUrl();
  const {
    mutateHomeQr,
    mutateLoading,
    isIdle,
    isSuccess
  } = useGenerateHomeQr();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const {
    setSolutionsType
  } = useSolutionsSelect();
  const signupModalState = useSignUpModal();
  const [inputFocus, setInputFocus] = useState(false);
  const {
    value: url,
    handleChange: handleUrlChange,
    handleInputBlur,
    clickedOutside
  } = useUrlInput(currentUrl, t);
  const isMobile = useMediaQuery({
    maxWidth: 1025
  });
  useEffect(() => {
    if (validationErrors && window && signupModalState.isTriedDownload && !mutateLoading && !isMobile) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [signupModalState.isTempTrigger, mutateLoading, validationErrors]);
  useEffect(() => {
    if (isSuccess && !validationErrors) {
      setSuccess(true);
    }
    if (validationErrors) {
      setSuccess(false);
    }
  }, [isSuccess, validationErrors]);
  useEffect(() => setIsLoading(mutateLoading), [mutateLoading]);
  const debouncedSetParams = useCallback(debounce((url, currentConfig) => {
    setParams({
      url
    });
    if (!mutateLoading) {
      mutateHomeQr({
        params: {
          url,
          config: currentConfig
        }
      });
    }
  }, 500), [setParams]);
  useEffect(() => {
    if (!isFirst && debouncedSetParams) {
      debouncedSetParams(url, config);
    }
    return () => debouncedSetParams.cancel();
  }, [isFirst, url, debouncedSetParams]);
  useEffect(() => {
    if (url) {
      setIsFirst(false);
    }
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUrlChange(e);
    setIsFirst(false);
  };
  const handleTextType = () => {
    setSolutionsType({
      solutionSelectedType: "text"
    });
  };
  const handleInputFocus = useCallback(() => {
    const inputCurrentRef = inputRef?.current;
    setInputFocus(true);
    if (inputCurrentRef) {
      inputCurrentRef.select();
      inputCurrentRef.scrollLeft = 0;
    }
  }, [inputRef]);
  const Icon = isMobile ? IoMdInformationCircleOutline : IoMdInformationCircle;
  return <div className={classes.Wrapper} data-sentry-component="Url" data-sentry-source-file="Url.tsx">
      <div className={classes.Header}>
        <span className={classes.step}>1</span>
        <p className={classes.TopTitle}>{t("description")}</p>
      </div>
      <div className={classes.InputBox}>
        <div className={classes.InputWrapper}>
          <TypeInput inputRef={inputRef} label={t("input.label")} value={url} name="url" placeholder={`https://www.${t("input.placeholder")}.com`} onChange={handleChange} onBlur={() => {
          handleInputBlur();
          setInputFocus(false);
        }} onFocus={handleInputFocus} success={everyTrue(inputFocus, validationErrors !== "pending", !validationErrors?.url?.length)} autoFocus={!!validationErrors?.url?.length} isRequired errors={validationErrors?.url?.length} customError={true} data-sentry-element="TypeInput" data-sentry-source-file="Url.tsx" />
          <When condition={isMobile} data-sentry-element="When" data-sentry-source-file="Url.tsx">
            <IFThen condition={success} Then={<HiCheckCircle size={20} color="#399930" className={classes.iconCircle} />} Else={!signupModalState.isTriedDownload && !!validationErrors && <HiExclamationCircle size={20} color="#E45541" className={classes.iconCircle} />} data-sentry-element="IFThen" data-sentry-source-file="Url.tsx" />
          </When>
        </div>
        <HomePageError errors={!signupModalState.isTriedDownload && validationErrors?.url} withIcon={!isMobile} parentStyle={{
        marginTop: isMobile ? "-4px" : "5px"
      }} data-sentry-element="HomePageError" data-sentry-source-file="Url.tsx" />
        {clickedOutside && <div className={classes.TextTypeHelper}>
            <p>
              <span>
                {" "}
                <Icon color="#0A9396" size={16} />
                {t("textHeading")}{" "}
              </span>
              <div className={classes.ClickTextType} onClick={handleTextType}>
                {t("textDesc")}
              </div>
            </p>
          </div>}
      </div>
    </div>;
};
export default Url;